<r1-compass-lib-instructions headerText="Grouping Logic">
    <r1-compass-lib-instructions headerText="">
        @if (instructionText()) {
            {{ instructionText() }}
        } @else {
            Set your desired grouping logic. For example, to use a simple match based on two criteria, your grouping
            logic might be (1 AND 2) or (1 OR 2). Advanced matching logic is limited to groups (), nested groups (())
            and "AND" and "OR" operators.
        }
    </r1-compass-lib-instructions>
    <div class="logic-main-container">
        <form [formGroup]="groupingLogicForm">
            <div class="logic-type-container">
                <mat-button-toggle-group
                    name="groupingLogicType"
                    formControlName="type"
                    (change)="onLogicTypeToggleChange(groupingLogicForm.controls.type.value)">
                    <mat-button-toggle
                        value="simple"
                        [ngClass]="
                            groupingLogicForm.controls.type.value === 'simple' ? 'button-toggled' : 'not-toggled'
                        "
                        >Simple
                    </mat-button-toggle>
                    <mat-button-toggle
                        value="complex"
                        [ngClass]="
                            groupingLogicForm.controls.type.value === 'complex' ? 'button-toggled' : 'not-toggled'
                        "
                        >Complex
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
            <r1-compass-lib-divider />
            <div class="logic-container">
                @if (groupingLogicForm.controls.type.value === 'simple') {
                    <mat-button-toggle-group
                        name="groupingLogicSimpleType"
                        formControlName="groupingLogic"
                        [value]="groupingLogicForm.controls.groupingLogic.value">
                        <mat-button-toggle
                            value="and"
                            [ngClass]="
                                groupingLogicForm.controls.groupingLogic.value === 'and'
                                    ? 'button-toggled'
                                    : 'not-toggled'
                            "
                            >AND
                        </mat-button-toggle>
                        <mat-button-toggle
                            value="or"
                            [ngClass]="
                                groupingLogicForm.controls.groupingLogic.value === 'or'
                                    ? 'button-toggled'
                                    : 'not-toggled'
                            "
                            >OR
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                } @else if (groupingLogicForm.controls.type.value === 'complex') {
                    <mat-form-field class="grouping-logic">
                        <mat-label>Grouping Logic</mat-label>
                        <input matInput type="text" formControlName="groupingLogic" />
                        <mat-error>Grouping logic is required</mat-error>
                    </mat-form-field>
                }
            </div>
        </form>
    </div>
</r1-compass-lib-instructions>
